<div class="left-menu-bar rail" *ngIf="showRail">
  <ng-container *ngIf="!activitiesLoading; else railItemLoading">
    <ng-container *ngIf="!onlyShowInvite">
      <ng-container *ngFor="let item of railActivitiesFormatStyle | keyvalue: sortActivities">
        <div
          [class]="'rail-item ' + item.value.railStyle.className"
          cdkOverlayOrigin
          #origin="cdkOverlayOrigin"
          (mouseenter)="onShowSubItem(item.key)"
          (mouseleave)="onCloseSubItem(5, item.key)"
          (click)="click(item.value.action)"
          [class.active-left-radius]="item.value.railStyle.hoverShow"
        >
          <img
            [class]="item.value.railStyle.imageClassName"
            [src]="item.value.railStyle.image | preferWebp"
            lazy="loading"
          />
          <img
            *ngIf="item.value.railStyle.imageTwo"
            [class]="item.value.railStyle.imageTwoClassName"
            [src]="item.value.railStyle.imageTwo | preferWebp"
            lazy="loading"
          />
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOpen]="!!(item.value.railStyle.hoverItem?.open && item.value.railStyle.hoverShow)"
            [cdkConnectedOverlayOrigin]="origin"
            [cdkConnectedOverlayPositions]="positions"
          >
            <div
              [class]="'rail-item active-right-radius ' + item.value.railStyle.hoverItem?.className"
              (mouseenter)="onShowSubItem(item.key)"
              (mouseleave)="onCloseSubItem(0, item.key)"
              (click)="click(item.value.railStyle.hoverItem?.action)"
            >
              <img
                [class]="item.value.railStyle.hoverItem?.imageClassName"
                [src]="item.value.railStyle.hoverItem?.image || '' | preferWebp"
                lazy="loading"
              />
              <img
                *ngIf="item.value.railStyle.hoverItem?.imageTwo"
                [class]="item.value.railStyle.hoverItem?.imageTwoClassName"
                [src]="item.value.railStyle.hoverItem?.imageTwo || '' | preferWebp"
                lazy="loading"
              />
            </div>
          </ng-template>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <div class="rail-item rail-invite" *ngIf="isLogined && onlyShowInvite" (click)="click('invite')">
    <img class="rail-invite-img" src="{{ 'assets/images/activity/left-bar/gifts.png' | preferWebp }}" lazy="loading" />
  </div>
</div>

<div class="activity-body full" *ngIf="showFully && !onlyShowInvite" [class.full]="hasActivities || activitiesLoading">
  <ng-container *ngIf="!activitiesLoading; else fullItemLoading">
    <div class="perks">
      <ng-container *ngFor="let item of activitiesFormatStyle | keyvalue: sortActivities">
        <div
          [class]="'perks-item ' + item.value.fullStyle.className"
          [class.long]="item.value.longStyle"
          [class.short]="!item.value.longStyle"
          (click)="click(item.value.action)"
        >
          <img
            [class]="item.value.fullStyle.imageClassName"
            [src]="item.value.fullStyle.image | preferWebp"
            lazy="loading"
          />
          <img
            *ngIf="item.value.fullStyle.imageTwo"
            [class]="item.value.fullStyle.imageTwoClassName"
            [src]="item.value.fullStyle.imageTwo | preferWebp"
            lazy="loading"
          />
          <div class="text">
            <p class="text-1">{{ item.value.fullStyle.text }}</p>
            <p *ngIf="item.value.fullStyle.secondText" class="text-2">{{ item.value.fullStyle.secondText }}</p>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>

<div class="invite-img-container">
  <div
    class="invite-img"
    [class.active]="getUrl.includes('referral')"
    *ngIf="isLogined && onlyShowInvite && !showRail"
    (click)="click('invite')"
  >
    <img class="gift-img" src="assets/images/activity/left-bar/gifts.png" lazy="loading" />
    <img
      class="inv-img"
      [src]="'assets/images/activity/left-bar/friend-invite-' + appService.languageCode + '.svg'"
      lazy="loading"
    />
  </div>
</div>

<ng-template #railItemLoading>
  <div class="rail-item skeleton-loading"></div>
  <div class="rail-item skeleton-loading"></div>
</ng-template>

<ng-template #fullItemLoading>
  <div class="perks">
    <div class="perks-item long skeleton-loading"></div>
    <div class="perks-item short skeleton-loading"></div>
    <div class="perks-item short skeleton-loading"></div>
  </div>
</ng-template>
